import { type ReactNode } from "react"
import { cn } from "~/utils/helpers"

type PageArchetype = "overview" | "workspace" | "analysis" | "settings"

type PageContentProps = {
  archetype: PageArchetype
  className?: string
  children: ReactNode
  fill?: boolean
}

const PageContent = ({ archetype, className, children, fill = false }: PageContentProps) => {
  if (archetype === "workspace") {
    return (
      <div className={cn("flex-1 min-h-0 min-w-0 flex flex-col p-4", className)}>{children}</div>
    )
  }

  if (archetype === "settings") {
    return (
      <div
        data-scroll-reset=""
        className={cn("flex-1 min-h-0 min-w-0 w-full overflow-y-auto", className)}
      >
        {children}
      </div>
    )
  }

  if (archetype === "overview") {
    if (fill) {
      return (
        <div className={cn("flex-1 min-h-0 min-w-0 w-full flex flex-col p-4", className)}>
          {children}
        </div>
      )
    }
    return (
      <div className="flex-1 min-h-0 min-w-0 w-full overflow-y-auto">
        <div className={cn("w-full p-4 min-h-full flex flex-col", className)}>{children}</div>
      </div>
    )
  }

  if (fill) {
    return (
      <div className={cn("flex-1 min-h-0 min-w-0 flex flex-col gap-4 p-4", className)}>
        {children}
      </div>
    )
  }

  return (
    <div className="flex-1 min-h-0 min-w-0 overflow-y-auto">
      <div className={cn("min-h-full flex flex-col gap-4 p-4", className)}>{children}</div>
    </div>
  )
}

export default PageContent
